import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";

// Clear any stale service worker / caches left by earlier builds so the latest
// bundle always wins inside the app WebView (prevents old screens sticking).
if ("serviceWorker" in navigator) {
  navigator.serviceWorker.getRegistrations().then((rs) => rs.forEach((r) => r.unregister())).catch(() => {});
}
if (window.caches && caches.keys) {
  caches.keys().then((ks) => ks.forEach((k) => caches.delete(k))).catch(() => {});
}

ReactDOM.createRoot(document.getElementById("root")).render(<App />);
